__turbopack_context__.v({
  "footnote": "SSlfOa_footnote",
});
